module.exports = __webpack_public_path__ + "static/media/logout.01e15138.svg";